// import React, { useEffect, useState, useContext, useRef } from "react";
// import Grid from "@mui/material/Grid";
// import Dvr from "@mui/icons-material/Dvr";
// import CheckCircle from "@mui/icons-material/CheckCircle";
// import Healing from "@mui/icons-material/Healing";
// import FilterCenterFocus from "@mui/icons-material/FilterCenterFocus";
// import Avatar from "@mui/material/Avatar";
// import Divider from "@mui/material/Divider";
// import LinearProgress from "@mui/material/LinearProgress";
// import LocalActivity from "@mui/icons-material/LocalActivity";
// import Typography from "@mui/material/Typography";
// import MainContext from "../../Services/Context/MainContext";
// import Cookies from "js-cookie";
// import jwtDecode from "jwt-decode";
// import "dan-styles/vendors/rechart/styles.css";
// import Button from "@mui/material/Button";
// import {
//   ComposedChart,
//   Line,
//   Area,
//   XAxis,
//   YAxis,
//   Tooltip,
//   CartesianGrid,
//   ResponsiveContainer,
// } from "recharts";
// import { dataPerformance } from "dan-api/chart/chartData";
// import colorfull from "dan-api/palette/colorfull";
// import useStyles from "./widget-jss";
// import { Paper } from "@mui/material";
// import raas from "/app/images/services/vlabs.webp";
// import vlab from "/app/images/services/vlabs.webp";
// import CounterWidget from "../Counter/CounterWidget";
// import Services from "../../Services/Services";
// import PapperBlock from "../PapperBlock/PapperBlock";
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
// import ListItemText from "@mui/material/ListItemText";
// import ListItemAvatar from "@mui/material/ListItemAvatar";
// import ImageIcon from "@mui/icons-material/Image";
// import WorkIcon from "@mui/icons-material/Work";
// import BeachAccessIcon from "@mui/icons-material/BeachAccess";
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
// import DialogTitle from "@mui/material/DialogTitle";
// import MUIDataTable from "mui-datatables";
// import Accordion from "@mui/material/Accordion";
// import AccordionDetails from "@mui/material/AccordionDetails";
// import AccordionSummary from "@mui/material/AccordionSummary";
// import Lottie from "react-lottie";
// import AwardAnimationLottie from "../../api/dummy/lotties/award-lotties.json";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// const color = {
//   main: colorfull[2],
//   secondary: colorfull[3],
//   third: colorfull[0],
//   fourth: colorfull[1],
// };

// function RewardCard(props) {
//   const { classes, cx } = useStyles();
//   const {
//     color,
//     start,
//     end,
//     duration,
//     title,
//     children,
//     unitBefore,
//     unitAfter,
//     rewardValue,
//   } = props;

//   const buttonRef = useRef(null);
//   const [lastX, setLastX] = useState(0);

//   const allContextDetails = useContext(MainContext);

//   const accessToken = Cookies.get("ac_token");
//   const decodeToken = jwtDecode(accessToken);
//   const [open, setOpen] = useState(false);
//   const [getRewardCount, setRewardCount] = useState(0);
//   const [getAppRewardPoints, setAppRewardPoints] = useState([]);
//   const [getNationalRank, setNationalRank] = useState();
//   const [getAllRewardbyActs, setAllRewardbyActs] = useState([]);

//   const columns = [
//     {
//       name: "Sl No",
//       options: {
//         filter: true,
//       },
//     },
//     {
//       name: "Activity",
//       options: {
//         filter: true,
//       },
//     },
//     {
//       name: "Reward Point",
//       options: {
//         filter: true,
//       },
//     },
//     {
//       name: "Time",
//       options: {
//         filter: true,
//       },
//     },
//   ];
//   const options = {
//     filterType: "dropdown",
//     responsive: "vertical",
//     print: true,
//     rowsPerPage: 10,
//     page: 0,
//     selectableRows: "none",
//     search: false,
//     filter: false,
//     print: false,
//     download: false,
//     viewColumns: false,
//   };
//   const [expanded, setExpanded] = React.useState(false);

//   const handleChange = (panel) => (event, isExpanded) => {
//     setExpanded(isExpanded ? panel : false);
//     getAllrewardByActivity(panel);
//   };

//   const handleClickOpenRewardModal = (appId) => {
//     setOpen(true);
//   };
//   const handleClickOpen = (appId, appName) => {
//     setOpen(true);
//     getAllrewardByActivity(appId);
//   };
//   const getAllrewardByActivity = async (appName) => {
//     const bodyjson = {
//       userid: allContextDetails.uid,
//       client_id: appName,
//     };
//     try {
//       const response = await Services.getRewardPointsByActivityAppwise(
//         bodyjson
//       );

//       if (response.status === 200) {
//         const appRewardbyActs = response.data.data;
//         setAllRewardbyActs(appRewardbyActs);
//       }
//     } catch (err) {}
//   };
//   const rewardData = getAllRewardbyActs.map((rewarPoint, index) => {
//     return [
//       index + 1,
//       rewarPoint.activity,
//       rewarPoint.reward_point,
//       rewarPoint.timestamp,
//     ];
//   });

//   const handleClose = () => {
//     setOpen(false);
//   };
//   useEffect(() => {
//     const bodyjson = { userid: decodeToken.sub };
//     const getRewardPoints = async () => {
//       try {
//         const response = await Services.getRewardPointsByActivity(bodyjson);

//         if (response.data.status === 1) {
//           const rewardValue = response.data.data.Reward_point;
//           const allAppRewardPoints = response.data.data.applications_data;
//           const national_rank = response.data.data["National Rank"];
//           setRewardCount(rewardValue);
//           setAppRewardPoints(allAppRewardPoints);
//           setNationalRank(national_rank);
//         }
//       } catch (err) {
//         console.log("reward err", err);
//       }
//     };
//     getRewardPoints();
//   }, []);
//   // console.log("getAppRewardPoints", getAppRewardPoints);
//   // const getIconBasedOnApp = (app) => {
//   //   if (app === "Arms") {
//   //     return <BeachAccessIcon />;
//   //   } else if (app === "elearning") {
//   //     return <WorkIcon />;
//   //   } else if (app === "ivp") {
//   //     return <LocalActivity />;
//   //   } else if (app === "ciso") {
//   //     return <CheckCircle />;
//   //   }
//   // };
//   const getIconBasedOnApp = (app) => {
//     const getFirstLetter = (app) => app.charAt(0).toUpperCase();
//     return <>{getFirstLetter(app)}</>;
//   };

//   const defaultOptions = {
//     loop: true,
//     autoplay: true,
//     animationData: AwardAnimationLottie,
//     rendererSettings: {
//       preserveAspectRatio: "xMidYMid slice",
//     },
//   };

//   return (
//     <div className={classes.borderPaperblock}>
//       {/*

//    <PapperBlock
//         whiteBg
//         noMargin
//         title="Total Reward Points"
//         icon="ion-ios-analytics-outline"
//         desc=""
//         rewardValue={getRewardCount}
//       >
//         <Grid container spacing={2}>
//           <Grid item md={12} xs={12} className="pt-0">
//             <div className={`${classes.root} mt-0`}>
//               <List>
//                 {getAppRewardPoints.map((items, index) => {
//                   return (
//                     <>
//                       <ListItem
//                         key={index}
//                         className={classes.appListItem}
//                         onClick={() =>
//                           handleClickOpen(items.app_id, items.app_name)
//                         }
//                       >
//                         <ListItemAvatar>
//                           <Avatar className={classes.avatarAmber}>
//                             {getIconBasedOnApp(items.app_name)}
//                           </Avatar>
//                         </ListItemAvatar>

//                         <ListItemText
//                           primary={items?.app_name}
//                           secondary={
//                             items?.total_reward_points
//                               ? items.total_reward_points
//                               : "0"
//                           }
//                           className={classes.listItemTextPoints}
//                         />
//                       </ListItem>
//                       <Divider variant="inset" component="li" />
//                     </>
//                   );
//                 })}
//               </List>
//             </div>
//             <div className="text-center">
//               <div className={classes.lifetimePoints}></div>
//             </div>
//           </Grid>
//         </Grid>
//         <div className={`${classes.DialogBoxSection} p-0`}>
//           <Dialog
//             open={open}
//             onClose={handleClose}
//             fullWidth
//             maxWidth="lg"
//             aria-labelledby="form-dialog-title"
//             className={`${classes.dailogBoxMain} p-0 `}
//             // PaperProps={{
//             //   lg: {
//             //     width: "100%",
//             //     maxHeight: 800,
//             //   },
//             // }}
//           >
//             <DialogContent>
//               <div className={`${classes.rootTable} ${classes.muiTableDialog}`}>
//                 <div className={`${classes.table} px-0`}>
//                   <MUIDataTable
//                     data={rewardData}
//                     columns={columns}
//                     options={options}
//                   />
//                 </div>
//               </div>
//             </DialogContent>

//             <DialogActions>
//               <Button onClick={handleClose} color="primary">
//                 Cancel
//               </Button>
//             </DialogActions>
//           </Dialog>
//         </div>
//       </PapperBlock>
//   */}
//       <Button
//         classes={{
//           root: cx(classes.gradientBtn, classes.margin),
//           label: classes.label,
//         }}
//         onClick={handleClickOpenRewardModal}
//       >
//         Rewards : {getRewardCount ? getRewardCount : "0"}
//         {/* <dotlottie-player
//           src="https://lottie.host/77d80f12-34e0-450b-bdb2-949de114afe3/NIMIeR0zGB.json"
//           speed="1"
//           loop
//           autoplay
//           className={classes.dotlottie}
//         ></dotlottie-player> */}
//         <Lottie options={defaultOptions} height={80} width={80} />
//       </Button>

//       <Dialog
//         open={open}
//         onClose={handleClose}
//         fullWidth
//         maxWidth="lg"
//         aria-labelledby="form-dialog-title"
//         className={classes.passResetDialog}
//         disableEnforceFocus
//         disableEscapeKeyDown
//         disableAutoFocus
//         disableRestoreFocus
//       >
//         <DialogTitle
//           id="form-dialog-title"
//           className={classes.rewardHeaderPointsCard}
//         >
//           <div>Total Reward Points:</div>
//           <div>{getRewardCount ? getRewardCount : "0"} </div>
//         </DialogTitle>

//         <DialogContent>
//           <Grid container spacing={2}>
//             <Grid item md={12} xs={12} className="pt-0">
//               <div className={`${classes.root} mt-0`}>
//                 <List>
//                   {getAppRewardPoints.length > 0 ? (
//                     getAppRewardPoints.map((items, index) => {
//                       return (
//                         <>
//                           <Accordion
//                             expanded={expanded === items.app_id}
//                             // defaultExpanded
//                             onChange={handleChange(items.app_id)}
//                           >
//                             <AccordionSummary
//                               expandIcon={<ExpandMoreIcon />}
//                               aria-controls="panel1bh-content"
//                               id="panel1bh-header"
//                             >
//                               <div
//                                 className={`${classes.accordianModalHeadeing} align-items-center justify-content-between w-100`}
//                               >
//                                 <Typography className={classes.heading}>
//                                   <Avatar
//                                     // className={classes.avatarAmber}
//                                     className={cx(
//                                       classes.avatar,
//                                       classes.tealAvatar
//                                     )}
//                                   >
//                                     {getIconBasedOnApp(items.app_id)}
//                                   </Avatar>
//                                 </Typography>
//                                 <div className={classes.headingModalReward}>
//                                   <Typography
//                                     className={classes.secondaryHeading}
//                                   >
//                                     {items?.app_name}
//                                   </Typography>
//                                   <Typography
//                                     className={`${classes.secondaryHeading} ${classes.rewardPointsValue}`}
//                                   >
//                                     {items?.total_reward_points
//                                       ? items.total_reward_points
//                                       : "0"}
//                                   </Typography>
//                                 </div>
//                               </div>
//                             </AccordionSummary>
//                             <AccordionDetails>
//                               <div
//                                 className={`${classes.rootTable} ${classes.muiTableDialog}`}
//                               >
//                                 <div className={`${classes.table} px-0`}>
//                                   <MUIDataTable
//                                     data={rewardData}
//                                     columns={columns}
//                                     options={options}
//                                   />
//                                 </div>
//                               </div>
//                             </AccordionDetails>
//                           </Accordion>
//                           <Divider variant="inset" component="li" />
//                         </>
//                       );
//                     })
//                   ) : (
//                     <p className="text-center text-danger"> *No Data Found </p>
//                   )}
//                 </List>
//               </div>
//               <div className="text-center">
//                 <div className={classes.lifetimePoints}></div>
//               </div>
//             </Grid>
//           </Grid>
//         </DialogContent>
//       </Dialog>
//     </div>
//   );
// }

// export default RewardCard;

import React, { useEffect, useState, useContext, useRef } from "react";
import Grid from "@mui/material/Grid";
import Dvr from "@mui/icons-material/Dvr";
import CheckCircle from "@mui/icons-material/CheckCircle";
import Healing from "@mui/icons-material/Healing";
import FilterCenterFocus from "@mui/icons-material/FilterCenterFocus";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import LinearProgress from "@mui/material/LinearProgress";
import LocalActivity from "@mui/icons-material/LocalActivity";
import Typography from "@mui/material/Typography";
import MainContext from "../../Services/Context/MainContext";
import Cookies from "js-cookie";
import jwtDecode from "jwt-decode";
import "dan-styles/vendors/rechart/styles.css";
import Button from "@mui/material/Button";
import {
  ComposedChart,
  Line,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { dataPerformance } from "dan-api/chart/chartData";
import colorfull from "dan-api/palette/colorfull";
import useStyles from "./widget-jss";
import { Paper } from "@mui/material";
import raas from "/app/images/services/vlabs.webp";
import vlab from "/app/images/services/vlabs.webp";
import CounterWidget from "../Counter/CounterWidget";
import Services from "../../Services/Services";
import PapperBlock from "../PapperBlock/PapperBlock";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ImageIcon from "@mui/icons-material/Image";
import WorkIcon from "@mui/icons-material/Work";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MUIDataTable from "mui-datatables";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Lottie from "react-lottie";
import AwardAnimationLottie from "../../api/dummy/lotties/award-lotties.json";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Tooltip } from "@mui/material";
const color = {
  main: colorfull[2],
  secondary: colorfull[3],
  third: colorfull[0],
  fourth: colorfull[1],
};

function RewardCard(props) {
  const { classes, cx } = useStyles();
  const {
    color,
    start,
    end,
    duration,
    title,
    children,
    unitBefore,
    unitAfter,
    rewardValue,
  } = props;

  const buttonRef = useRef(null);
  const [lastX, setLastX] = useState(0);

  const allContextDetails = useContext(MainContext);

  const accessToken = Cookies.get("ac_token");
  const decodeToken = jwtDecode(accessToken);
  const [open, setOpen] = useState(false);
  const [getRewardCount, setRewardCount] = useState(0);
  const [getAppRewardPoints, setAppRewardPoints] = useState([]);
  const [getNationalRank, setNationalRank] = useState();
  const [getAllRewardbyActs, setAllRewardbyActs] = useState([]);

  const columns = [
    {
      name: "Sl No",
      options: {
        filter: true,
      },
    },
    {
      name: "Activity",
      options: {
        filter: true,
      },
    },
    {
      name: "Reward Point",
      options: {
        filter: true,
      },
    },
    {
      name: "Time",
      options: {
        filter: true,
      },
    },
  ];
  const options = {
    filterType: "dropdown",
    responsive: "vertical",
    print: true,
    rowsPerPage: 10,
    page: 0,
    selectableRows: "none",
    search: false,
    filter: false,
    print: false,
    download: false,
    viewColumns: false,
  };
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    getAllrewardByActivity(panel);
  };

  const handleClickOpenRewardModal = (appId) => {
    setOpen(true);
  };
  const handleClickOpen = (appId, appName) => {
    setOpen(true);
    getAllrewardByActivity(appId);
  };
  const getAllrewardByActivity = async (appName) => {
    const bodyjson = {
      userid: allContextDetails.uid,
      client_id: appName,
    };
    try {
      const response = await Services.getRewardPointsByActivityAppwise(
        bodyjson
      );

      if (response.status === 200) {
        const appRewardbyActs = response.data.data;
        setAllRewardbyActs(appRewardbyActs);
      }
    } catch (err) {}
  };
  const rewardData = getAllRewardbyActs.map((rewarPoint, index) => {
    return [
      index + 1,
      rewarPoint.activity,
      rewarPoint.reward_point,
      rewarPoint.timestamp,
    ];
  });

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    const bodyjson = { userid: decodeToken.sub };
    const getRewardPoints = async () => {
      try {
        const response = await Services.getRewardPointsByActivity(bodyjson);

        if (response.data.status === 1) {
          const rewardValue = response.data.data.Reward_point;
          const allAppRewardPoints = response.data.data.applications_data;
          const national_rank = response.data.data["National Rank"];
          setRewardCount(rewardValue);
          setAppRewardPoints(allAppRewardPoints);
          setNationalRank(national_rank);
        }
      } catch (err) {
        console.log("reward err", err);
      }
    };
    getRewardPoints();
  }, []);
  // console.log("getAppRewardPoints", getAppRewardPoints);
  // const getIconBasedOnApp = (app) => {
  //   if (app === "Arms") {
  //     return <BeachAccessIcon />;
  //   } else if (app === "elearning") {
  //     return <WorkIcon />;
  //   } else if (app === "ivp") {
  //     return <LocalActivity />;
  //   } else if (app === "ciso") {
  //     return <CheckCircle />;
  //   }
  // };
  const getIconBasedOnApp = (app) => {
    const getFirstLetter = (app) => app.charAt(0).toUpperCase();
    return <>{getFirstLetter(app)}</>;
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: AwardAnimationLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const formatNumber = (num) => {
    if (num >= 1e9) return `${(num / 1e9).toFixed(1)}b+`;
    if (num >= 1e6) return `${(num / 1e6).toFixed(1)}m+`;
    if (num >= 1e3) return `${(num / 1e3).toFixed(1)}k+`;
    return num.toString();
  };
  return (
    <div className={classes.borderPaperblock}>
      {/* 
  
   <PapperBlock
        whiteBg
        noMargin
        title="Total Reward Points"
        icon="ion-ios-analytics-outline"
        desc=""
        rewardValue={getRewardCount}
      >
        <Grid container spacing={2}>
          <Grid item md={12} xs={12} className="pt-0">
            <div className={`${classes.root} mt-0`}>
              <List>
                {getAppRewardPoints.map((items, index) => {
                  return (
                    <>
                      <ListItem
                        key={index}
                        className={classes.appListItem}
                        onClick={() =>
                          handleClickOpen(items.app_id, items.app_name)
                        }
                      >
                        <ListItemAvatar>
                          <Avatar className={classes.avatarAmber}>
                            {getIconBasedOnApp(items.app_name)}
                          </Avatar>
                        </ListItemAvatar>

                        <ListItemText
                          primary={items?.app_name}
                          secondary={
                            items?.total_reward_points
                              ? items.total_reward_points
                              : "0"
                          }
                          className={classes.listItemTextPoints}
                        />
                      </ListItem>
                      <Divider variant="inset" component="li" />
                    </>
                  );
                })}
              </List>
            </div>
            <div className="text-center">
              <div className={classes.lifetimePoints}></div>
            </div>
          </Grid>
        </Grid>
        <div className={`${classes.DialogBoxSection} p-0`}>
          <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="lg"
            aria-labelledby="form-dialog-title"
            className={`${classes.dailogBoxMain} p-0 `}
            // PaperProps={{
            //   lg: {
            //     width: "100%",
            //     maxHeight: 800,
            //   },
            // }}
          >
            <DialogContent>
              <div className={`${classes.rootTable} ${classes.muiTableDialog}`}>
                <div className={`${classes.table} px-0`}>
                  <MUIDataTable
                    data={rewardData}
                    columns={columns}
                    options={options}
                  />
                </div>
              </div>
            </DialogContent>

            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </PapperBlock>
  */}
      <Tooltip title={`Rewards Count: ${getRewardCount || "0"}`}>
        <Button
          classes={{
            root: cx(classes.gradientBtn, classes.margin),
            label: classes.label,
          }}
          onClick={handleClickOpenRewardModal}
        >
          Rewards: {formatNumber(getRewardCount)}
          {/* <dotlottie-player
          src="https://lottie.host/77d80f12-34e0-450b-bdb2-949de114afe3/NIMIeR0zGB.json"
          speed="1"
          loop
          autoplay
          className={classes.dotlottie}
        ></dotlottie-player> */}
          <Lottie options={defaultOptions} height={80} width={80} />
        </Button>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
        aria-labelledby="form-dialog-title"
        className={classes.passResetDialog}
        disableEnforceFocus
        disableEscapeKeyDown
        disableAutoFocus
        disableRestoreFocus
      >
        <DialogTitle
          id="form-dialog-title"
          className={classes.rewardHeaderPointsCard}
        >
          <div>Total Reward Points:</div>
          <div>{getRewardCount ? getRewardCount : "0"} </div>
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={2}>
            <Grid item md={12} xs={12} className="pt-0">
              <div className={`${classes.root} mt-0`}>
                <List>
                  {getAppRewardPoints.length > 0 ? (
                    getAppRewardPoints.map((items, index) => {
                      return (
                        <>
                          <Accordion
                            expanded={expanded === items.app_id}
                            // defaultExpanded
                            onChange={handleChange(items.app_id)}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1bh-content"
                              id="panel1bh-header"
                            >
                              <div
                                className={`${classes.accordianModalHeadeing} align-items-center justify-content-between w-100`}
                              >
                                <Typography className={classes.heading}>
                                  <Avatar
                                    // className={classes.avatarAmber}
                                    className={cx(
                                      classes.avatar,
                                      classes.tealAvatar
                                    )}
                                  >
                                    {getIconBasedOnApp(items.app_id)}
                                  </Avatar>
                                </Typography>
                                <div className={classes.headingModalReward}>
                                  <Typography
                                    className={classes.secondaryHeading}
                                  >
                                    {items?.app_name}
                                  </Typography>
                                  <Typography
                                    className={`${classes.secondaryHeading} ${classes.rewardPointsValue}`}
                                  >
                                    {items?.total_reward_points
                                      ? items.total_reward_points
                                      : "0"}
                                  </Typography>
                                </div>
                              </div>
                            </AccordionSummary>
                            <AccordionDetails>
                              <div
                                className={`${classes.rootTable} ${classes.muiTableDialog}`}
                              >
                                <div className={`${classes.table} px-0`}>
                                  <MUIDataTable
                                    data={rewardData}
                                    columns={columns}
                                    options={options}
                                  />
                                </div>
                              </div>
                            </AccordionDetails>
                          </Accordion>
                          <Divider variant="inset" component="li" />
                        </>
                      );
                    })
                  ) : (
                    <p className="text-center text-danger"> *No Data Found </p>
                  )}
                </List>
              </div>
              <div className="text-center">
                <div className={classes.lifetimePoints}></div>
              </div>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default RewardCard;
